<template>
    <vue-form
        :form-config="billAccountFormConfiguration"
        :form-data="currentAccount"
        @cancel-form="closeForm"
        @close-form="closeForm"
        @created="updateOrAddBillAccount"
        @updated="updateOrAddBillAccount"
        :form-submit-url="'/api/bill_accounts/project/' + projectId"
        :disabled="disabled"
        :close-on-save="false"
        :actions="formActions"
    ></vue-form>
</template>
<script>
    export default {

        props: {
            billAccount: {
                required: false,
                type: Object,
                default() {
                    return {}
                }
            },
            disabled: {
                required: true,
                type: Boolean
            }
        },

        inject: {
            projectId: {
                default() {
                    return null;
                }
            },
            billAccountFormConfiguration: {
                default() {
                    console.error('Invalid Form Configuration provided');
                    return null;
                }
            }
        },

        data() {
            return {
                currentAccount:{
                },
                formActions: [
                    {
                        label: 'Save',
                        name: 'submit',
                        action: 'submitForm'
                    },
                    {
                        label: 'Cancel',
                        name: 'cancel',
                        action: 'cancelForm'
                    }
                ]
            }
        },

        created() {
            if (Object.entries(this.billAccount).length > 0) {
                this.currentAccount = this.billAccount;
            } else {
                this.currentAccount = {
                    'project_id': this.projectId
                }

            }
        },

        methods: {
            closeForm() {
                this.$emit('close');
            },
            updateOrAddBillAccount(billAccount) {
                this.$emit('savedBillAccount', billAccount);
            }
        }
    }
</script>
